import { render } from "./scan-table-section.vue?vue&type=template&id=2d60c421&scoped=true&ts=true"
import script from "./scan-table-section.vue?vue&type=script&lang=ts"
export * from "./scan-table-section.vue?vue&type=script&lang=ts"

import "./scan-table-section.vue?vue&type=style&index=0&id=2d60c421&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d60c421"]])

export default __exports__